import { withPaymentLink } from '@/composables/usePaymentLink'

/**
 * Deep link that reopens this page inside the Lark client.
 *
 * The target is rebuilt rather than passing `window.location.href` straight
 * through, because by this point the query string is not what arrived:
 * `usePaymentLink` has already removed `_ptxn`, and an OAuth `code` may still
 * be sitting there. Carrying the code over would hand Lark a single-use
 * credential that is already spent; dropping the transaction id would lose the
 * payment the customer clicked the mail to make. So: drop the query, then put
 * back only the transaction — a customer who would rather pay inside Lark
 * lands on the checkout, not on the dashboard.
 */
export function larkAppLink(): string {
  const target = new URL(window.location.href)
  target.search = ''
  const currentUrl = encodeURIComponent(withPaymentLink(target).toString())
  return `https://applink.larksuite.com/client/web_url/open?mode=appCenter&url=${currentUrl}`
}
